import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, NgModule } from '@angular/core';
import * as i2 from 'base-digital-signature-library';
import { BaseDigitalSignatureLibraryService } from 'base-digital-signature-library';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'app-services-library';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6 from 'primeng/radiobutton';
import * as i7 from '@angular/common';
import * as i8 from 'primeng/button';
import * as i9 from 'primeng/checkbox';
import { OverideUploadFormsLibraryModule } from 'overide-upload-forms-library';
import { OverrideRadioButtonLibraryModule } from 'override-radio-button-library';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';

class DigitalSignatureLibraryService {
    constructor() { }
}
DigitalSignatureLibraryService.ɵfac = function DigitalSignatureLibraryService_Factory(t) { return new (t || DigitalSignatureLibraryService)(); };
DigitalSignatureLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: DigitalSignatureLibraryService, factory: DigitalSignatureLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DigitalSignatureLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["createTemplateForm"];
function DigitalSignatureLibraryComponent_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "p-checkbox", 13);
    i0.ɵɵlistener("ngModelChange", function DigitalSignatureLibraryComponent_div_8_div_4_Template_p_checkbox_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.selectedSignatures = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls)("value", item_r3)("label", item_r3.name)("ngModel", ctx_r2.selectedSignatures);
} }
function DigitalSignatureLibraryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "Span");
    i0.ɵɵtext(2, " Select whose image signature you want to add? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵtemplate(4, DigitalSignatureLibraryComponent_div_8_div_4_Template, 2, 4, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵelementStart(7, "button", 11);
    i0.ɵɵlistener("click", function DigitalSignatureLibraryComponent_div_8_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.handleSaveSignatureInfo(); });
    i0.ɵɵtext(8, "SAVE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.digiSignarture.signatureInfo);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r1.disabledControls);
} }
class DigitalSignatureLibraryComponent extends BaseDigitalSignatureLibraryService {
    constructor(store, apiService, toastr, appServicesLibraryService) {
        super(store, apiService, toastr, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.appServicesLibraryService = appServicesLibraryService;
    }
    ngOnInit() {
        super.loadInit();
        // console.log(this.disabledControls)
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
DigitalSignatureLibraryComponent.ɵfac = function DigitalSignatureLibraryComponent_Factory(t) { return new (t || DigitalSignatureLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIDigitalSignature), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.AppServicesLibraryService)); };
DigitalSignatureLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DigitalSignatureLibraryComponent, selectors: [["lib-digital-signature-library"]], viewQuery: function DigitalSignatureLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.digiSigForm = _t.first);
    } }, inputs: { primaryData: "primaryData", docType: "docType" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 8, consts: [["digiSigForm", "ngForm"], [1, "container-fluid", "entry-class", "mb-3"], [1, "pl-0", "pt-3"], ["name", "digiSignature", "label", "Yes", 1, "letter-radio", 3, "disabled", "ngModel", "value", "onClick", "ngModelChange"], ["name", "digiSignature", "label", "No", 1, "letter-radio", 3, "disabled", "ngModel", "value", "onClick", "ngModelChange"], ["class", "container-fluid entry-class", 4, "ngIf"], [1, "container-fluid", "entry-class"], [1, "row", "pl-0", "pt-3"], ["class", "col-3", 4, "ngFor", "ngForOf"], [1, "row", "pt-2"], [1, "col-2"], ["type", "button", "pButton", "", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "col-3"], ["name", "signature", 3, "disabled", "value", "label", "ngModel", "ngModelChange"]], template: function DigitalSignatureLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", null, 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "Span");
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵelementStart(6, "p-radioButton", 3);
        i0.ɵɵlistener("onClick", function DigitalSignatureLibraryComponent_Template_p_radioButton_onClick_6_listener() { return ctx.handleSignatureSelection(true); })("ngModelChange", function DigitalSignatureLibraryComponent_Template_p_radioButton_ngModelChange_6_listener($event) { return ctx.digiSignarture.isRequired = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "p-radioButton", 4);
        i0.ɵɵlistener("onClick", function DigitalSignatureLibraryComponent_Template_p_radioButton_onClick_7_listener() { return ctx.handleSignatureSelection(false); })("ngModelChange", function DigitalSignatureLibraryComponent_Template_p_radioButton_ngModelChange_7_listener($event) { return ctx.digiSignarture.isRequired = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, DigitalSignatureLibraryComponent_div_8_Template, 9, 2, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" Would you like to use image signature on ", ctx.signatureCapturedFor, "? ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("ngModel", ctx.digiSignarture.isRequired)("value", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("ngModel", ctx.digiSignarture.isRequired)("value", false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.digiSignarture.isRequired);
    } }, directives: [i5.ɵangular_packages_forms_forms_ba, i5.NgControlStatusGroup, i5.NgForm, i6.RadioButton, i5.NgControlStatus, i5.NgModel, i7.NgIf, i7.NgForOf, i8.ButtonDirective, i9.Checkbox], styles: [".row[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DigitalSignatureLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-digital-signature-library',
                templateUrl: 'digital-signature-library.component.html',
                styleUrls: ['digital-signature-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIDigitalSignature }, { type: i3.ToastrService }, { type: i4.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], docType: [{
            type: Input
        }], digiSigForm: [{
            type: ViewChild,
            args: ['createTemplateForm', { static: true }]
        }] }); })();

class DigitalSignatureLibraryModule {
}
DigitalSignatureLibraryModule.ɵfac = function DigitalSignatureLibraryModule_Factory(t) { return new (t || DigitalSignatureLibraryModule)(); };
DigitalSignatureLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: DigitalSignatureLibraryModule });
DigitalSignatureLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseDigitalSignatureLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            FormsModule,
            OverrideRadioButtonLibraryModule,
            OverideUploadFormsLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DigitalSignatureLibraryModule, { declarations: [DigitalSignatureLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        FormsModule,
        OverrideRadioButtonLibraryModule,
        OverideUploadFormsLibraryModule], exports: [DigitalSignatureLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DigitalSignatureLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [DigitalSignatureLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    FormsModule,
                    OverrideRadioButtonLibraryModule,
                    OverideUploadFormsLibraryModule
                ],
                providers: [BaseDigitalSignatureLibraryService],
                exports: [DigitalSignatureLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of digital-signature-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DigitalSignatureLibraryComponent, DigitalSignatureLibraryModule, DigitalSignatureLibraryService };
//# sourceMappingURL=digital-signature-library.js.map
